import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/Home',
      name: 'home',
      component: () => import('../components/Home.vue')
    },
	{
	  path: '/Success',
	  name: 'success',
	  component: () => import('../components/Success.vue')
	},
	{
	  path: '/Invalid',
	  name: 'invalid',
	  component: () => import('../components/Invalid.vue')
	},
	{
	  path: '/Warning',
	  name: 'warning',
	  component: () => import('../components/Warning.vue')
	},
	{
	  path: '/',
	  redirect: '/Home'
	},
  ]
})
